import en from './english';
import ja from './japanese';
import zh from './chinese';

export default { en, ja, zh };